import { useMutation } from '@tanstack/react-query';

import type {
  PaymentCardFormData,
  PaymentCardFormResponse,
} from '@/types/api/mutations/paymentCard';

import { HttpClient } from '@/network/HttpClient';

export const usePaymentCardFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: PaymentCardFormData;
    }) =>
      HttpClient.request<PaymentCardFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });
